import { render } from "./RefreshButton.vue?vue&type=template&id=2aa37c57"
import script from "./RefreshButton.vue?vue&type=script&lang=js"
export * from "./RefreshButton.vue?vue&type=script&lang=js"
script.render = render

export default script